import { action, extendObservable } from 'mobx';
import FormService from '../../../core/services/FormService';
import FetchService from '../../../core/services/FetchService';

class ExportCsvService {
  form = new FormService();
  download = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
  }

  init = action(() => {
    this.form.reset();
  });

  handleOpenDialog = action(() => {
    this.isOpen = true;
    this.form.reset();
    this.form.setInitialValues({ type: 'ALL' });
    this.download.error = null;
  });

  handleCloseDialog = action(() => {
    this.isOpen = false;
  });

  handleDownload = action(() => {
    this.download
      .fetch({
        responseType: 'blob',
        url: `/localization-items/export`,
        query: {
          type: this.form.getValue('type') === 'ALL' ? null : this.form.getValue('type'),
          locale: this.form.getValue('locale'),
        },
      })
      .then(() => {
        if (this.download.data) {
          const link = document.createElement('a');
          const fileUrl = window.URL.createObjectURL(this.download.data);
          link.href = fileUrl;

          link.download = `localization-items-export.csv`;
          link.click();
          setTimeout(() => window.URL.revokeObjectURL(fileUrl), 500);
          this.isOpen = false;
        }
      });
  });
}

const exportCsvService = new ExportCsvService();
export default exportCsvService;
